// extracted by mini-css-extract-plugin
export default {"layout":"styles_layout__L0LlG","card":"styles_card__gzOxp"};